import { Injectable } from '@angular/core';

export interface CollegeSearchState {
  selectedCountry: string | null;
  collegeName: any;
  first: number;
  rowSize: number;
}

@Injectable({ providedIn: 'root' })
export class CollegeSearchStateService {
  state: CollegeSearchState | null = null;

  save(state: CollegeSearchState) {
    this.state = state;
  }

  clear() {
    this.state = null;
  }
}